import useGlobalContext from "hooks/globalData";
import { useState } from "react";
import { useQueryClient } from "react-query";
import {
  ManualSubmissionFilter,
} from "services/KnowfullyAdminClient";
import { Button, CircularProgress } from "@mui/material";
import { FormattedMessage as T, useIntl } from "react-intl";
import SnackbarMessage from "components/SnackbarMessage";
import { Severity, SnackbarMessageProps } from "types/common-types";

type SubmissionReportsExporterProps = {
  filter: ManualSubmissionFilter;
};

const SubmissionReportsExporter = ({
  filter,
}: SubmissionReportsExporterProps) => {
  const [isExporting, setExporting] = useState(false);
  const [isExportCompleted, setExportCompleted] = useState(false);
  const queryClient = useQueryClient();
  const { submissionService } = useGlobalContext();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);
  const { formatMessage: t } = useIntl();
  const errorExportingSnackbarProps = new SnackbarMessageProps(
    t({ id: "reportExportError" }),
    Severity.Error,
    5000
  );
  const onClick = async () => {
    try {
      setExporting(true);

      const result = await submissionService.processManualSubmission(filter);
      queryClient.invalidateQueries(["manualCreditSubmissionPreview"]);
      queryClient.invalidateQueries(["getPreviouslyExportedProcessings"]);

      window.open(result.reportFileUrl);
    } catch (error) {
      setSnackbarMessage(errorExportingSnackbarProps);
    } finally {
      setExportCompleted(true);
      setExporting(false);
    }
  };

  return (
    <>
      <Button
        onClick={onClick}
        type="button"
        color="primary"
        variant="outlined"
        disabled={isExporting || isExportCompleted}
      >
        {isExporting ? <CircularProgress size={25} /> : <T id="exportButton" />}
      </Button>

      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
};

export default SubmissionReportsExporter;
